<app-ajax-loader></app-ajax-loader>

<div class="main-container-wrap" *ngIf="!location.path().includes('CPO/page/Add') ">

  <app-header></app-header>
  <app-sidebar></app-sidebar>

  <main id="main" class="main wo-side-nav">
    <div class="page-cont">

      <router-outlet *ngIf="!isIframe"></router-outlet>
      <div *ngIf="!isNotAllowed && !isTerminated; else notallowed">

      </div>
      <ng-template #notallowed>
        <app-access-denied *ngIf="isNotAllowed && isTerminated" [isTerminated] ="isTerminated"></app-access-denied>

      </ng-template>

      <app-redirect></app-redirect>



    </div>
  </main>
  <div class="footer_2">
    <app-footer></app-footer>
  </div>
</div>

<div class="main-container-wrap full-width" *ngIf="location.path().includes('CPO/page/Add')">
  <main class="main login-main p-0">
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <app-redirect></app-redirect>
  </main>
  <!--<div class="footer_2">
    <app-footer></app-footer>
  </div>-->
</div>

